import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { UserStatus } from '../../store/auth/authSlice';

export const useAuthRedirect = () => {
    const { user } = useSelector((state) => state.auth);
    const { pathname } = useLocation();

    const publicRoutes = ['/login', '/forgot'];

    if (!user && !publicRoutes.includes(pathname)) {
        return '/login';
    }

    if (
        user &&
        user.status === UserStatus.ACTIVE &&
        user.isAdmin &&
        publicRoutes.includes(pathname)
    ) {
        return '/';
    }

    return null;
};
